import { Box, Stack, Heading, Text, Divider, Flex } from '@chakra-ui/react'
import CustomLink from '@/components/CustomLink'
import { Suspense } from 'react'

import logo from '@/assets/TheLordHeritage_logo.png'
import LoginForm from '@/modules/login/LoginForm'

const LOGO_DIMENSION = 187

export default function ParentLogin() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Flex
                minH={'100vh'}
                h={'100%'}
                align={'center'}
                justify={'center'}
                bg={'gray.50'}
            >
                <Stack
                    spacing={8}
                    mx={'auto'}
                    minW={['sm', 'md']}
                    maxW={'lg'}
                    py={12}
                    px={6}
                >
                    <Stack align={'center'}>
                        <img
                            src={logo}
                            alt="church logo"
                            width={LOGO_DIMENSION}
                            height={LOGO_DIMENSION}
                            loading="eager"
                        />
                        <Heading fontSize={'2xl'}>Account Login</Heading>
                        <Text fontSize={{ base: 'sm', sm: 'md' }} color={'gray.600'}>
                            Welcome, login to your account 🔐
                        </Text>
                    </Stack>

                    <Box rounded={'lg'} bg={'white'} boxShadow={'lg'} p={8}>
                        <Stack spacing={4}>
                            <LoginForm />
                            <Stack>
                                <Divider />
                                <Text align={'center'}>
                                    If you are a <strong>new parent or teacher</strong>,
                                    register below 👇
                                </Text>
                                <CustomLink
                                    borderColor={'brand.400'}
                                    color={'brand.400'}
                                    px={2}
                                    py={2}
                                    align={'center'}
                                    border={'1px solid'}
                                    borderRadius="6px"
                                    _hover={{
                                        textDecoration: 'none',
                                        backgroundColor: 'brand.50',
                                        color: 'brand.900'
                                    }}
                                    _focus={{ outline: 'none', boxShadow: 'none' }}
                                    href="/account/signup"
                                >
                                    Create new account
                                </CustomLink>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </Flex>
        </Suspense>
    )
}
